import React, { useState } from 'react';
import { LayoutDashboard, Calendar, Users, FileText, CheckSquare, Menu, X } from 'lucide-react';

// Import các component của 5 tab bên phải
import DashboardLocationView from './components/DashboardLocationView';
import AppointmentManagement from './components/AppointmentManagement';
import ReceptionManagement from './components/ReceptionManagement';
import ConsultingManagement from './components/ConsultingManagement';
import ExecutionManagement from './components/ExecutionManagement';

export default function TienTrinh() {
  const [currentTab, setCurrentTab] = useState('dashboard');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  const menuItems = [
    {
      key: 'dashboard',
      step: '01',
      title: 'Bảng điều hành',
      subtitle: 'Vào ca — hôm nay nặng ở đầu',
      badge: '4 việc quá hạn',
      badgeColor: 'bg-red-50 text-red-600 border border-red-200 dark:bg-red-950/50 dark:text-red-400 dark:border-red-900',
      icon: <LayoutDashboard className="w-4 h-4" />
    },
    {
      key: 'appointments',
      step: '02',
      title: 'Lịch hẹn',
      subtitle: 'Hẹn tương lai và việc chạm lại',
      badge: '1 quá hạn chạm lại',
      badgeColor: 'bg-amber-50 text-amber-600 border border-amber-200 dark:bg-amber-950/50 dark:text-amber-400 dark:border-amber-900',
      icon: <Calendar className="w-4 h-4" />
    },
    {
      key: 'reception',
      step: '03',
      title: 'Tiếp đón & Check-in',
      subtitle: 'Khách có mặt tại cơ sở',
      badge: '4 quá giờ chưa đến',
      badgeColor: 'bg-orange-50 text-orange-600 border border-orange-200 dark:bg-orange-950/50 dark:text-orange-400 dark:border-orange-900',
      icon: <Users className="w-4 h-4" />
    },
    {
      key: 'consulting',
      step: '04',
      title: 'Lịch tư vấn',
      subtitle: 'Chốt hoặc rớt, có lý do',
      badge: '8 việc chờ xử lý',
      badgeColor: 'bg-blue-50 text-blue-600 border border-blue-200 dark:bg-blue-950/50 dark:text-blue-400 dark:border-blue-900',
      icon: <FileText className="w-4 h-4" />
    },
    {
      key: 'execution',
      step: '05',
      title: 'Lịch thực hiện',
      subtitle: 'Phòng, ekip, thiết bị',
      badge: '6 ca chờ xếp lịch',
      badgeColor: 'bg-gray-100 text-gray-600 border border-gray-200 dark:bg-slate-800 dark:text-gray-300 dark:border-slate-700',
      icon: <CheckSquare className="w-4 h-4" />
    },
  ];

  const renderRightContent = () => {
    switch (currentTab) {
      case 'dashboard':
        return <DashboardLocationView />;
      case 'appointments':
        return <AppointmentManagement />;
      case 'reception':
        return <ReceptionManagement />;
      case 'consulting':
        return <ConsultingManagement />;
      case 'execution':
        return <ExecutionManagement />;
      default:
        return <DashboardLocationView />;
    }
  };

  return (
    <div className={`flex h-screen overflow-hidden font-sans ${isDarkMode ? 'dark bg-slate-950 text-slate-100' : 'bg-gray-50 text-slate-800'}`}>
      
      {/* Mobile Top Bar (Chỉ hiển thị trên màn hình nhỏ) */}
      <div className="md:hidden absolute top-0 left-0 right-0 h-14 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-800 z-30 flex items-center justify-between px-4">
        <div className="font-bold text-sm text-slate-800 dark:text-white">TIẾN TRÌNH KHÁCH HÀNG</div>
        <div className="flex items-center space-x-2">
          {/* <button 
            onClick={() => setIsDarkMode(!isDarkMode)}
            className="p-2 rounded-lg bg-gray-100 dark:bg-slate-800 text-xs font-semibold"
          >
            {isDarkMode ? '🌞 Sáng' : '🌙 Tối'}
          </button> */}
          <button 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2 rounded-lg bg-gray-100 dark:bg-slate-800 text-slate-700 dark:text-slate-200"
          >
            {mobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {/* Menu bên trái (Responsive: Ẩn trên mobile, hiện dạng slide/drawer; Cố định trên Desktop) */}
      <div className={`
        fixed md:relative inset-y-0 left-0 z-40 w-[230px] flex-shrink-0 
        bg-white dark:bg-slate-900 border-r border-gray-200 dark:border-slate-800 p-4 select-none 
        h-screen overflow-y-auto transition-transform duration-300 ease-in-out
        ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
      `}>
        <div className="hidden md:flex justify-between items-center mb-4 px-2">
          <div className="font-bold text-gray-400 dark:text-gray-500 text-xs tracking-wider uppercase">
            TIẾN TRÌNH KHÁCH HÀNG
          </div>
          {/* <button 
            onClick={() => setIsDarkMode(!isDarkMode)}
            className="text-[11px] px-2 py-1 rounded bg-gray-100 dark:bg-slate-800 text-gray-600 dark:text-gray-300 hover:bg-gray-200 transition"
          >
            {isDarkMode ? '🌞 Sáng' : '🌙 Tối'}
          </button> */}
        </div>
        
        <div className="space-y-2 mt-12 md:mt-0">
          {menuItems.map((item) => {
            const isActive = currentTab === item.key;
            return (
              <div
                key={item.key}
                onClick={() => {
                  setCurrentTab(item.key);
                  setMobileMenuOpen(false); // Chọn xong tự đóng menu trên mobile
                }}
                className={`flex items-start p-3 rounded-xl cursor-pointer transition-all duration-200 ${
                  isActive 
                    ? 'bg-blue-50/80 border border-blue-200 text-blue-900 shadow-sm dark:bg-blue-950/40 dark:border-blue-800 dark:text-blue-200' 
                    : 'hover:bg-gray-50 text-gray-700 border border-transparent dark:hover:bg-slate-800/50 dark:text-gray-300'
                }`}
              >
                <div className={`mt-0.5 font-bold text-sm ${isActive ? 'text-blue-600 dark:text-blue-400' : 'text-gray-400 dark:text-gray-500'}`}>
                  {item.step}
                </div>

                <div className="flex-1 min-w-0 ml-3">
                  <div className={`font-semibold text-sm leading-tight ${isActive ? 'text-blue-900 dark:text-blue-200' : 'text-gray-800 dark:text-gray-200'}`}>
                    {item.title}
                  </div>
                  <div className="text-[11px] text-gray-500 dark:text-gray-400 mt-0.5">
                    {item.subtitle}
                  </div>
                  <div className="mt-2">
                    <span className={`inline-block text-[10px] font-medium px-2 py-0.5 rounded-md ${item.badgeColor}`}>
                      ● {item.badge}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Backdrop mờ khi mở menu trên mobile */}
      {mobileMenuOpen && (
        <div 
          onClick={() => setMobileMenuOpen(false)}
          className="fixed inset-0 bg-black/50 z-30 md:hidden"
        />
      )}

      {/* Vùng nội dung bên phải tự cuộn độc lập (Có thêm khoảng cách phía trên trên mobile để tránh thanh topbar) */}
      <div className="flex-1 h-screen overflow-y-auto pt-14 md:pt-0 bg-gray-50 dark:bg-slate-950">
        {renderRightContent()}
      </div>
    </div>
  );
}